import {
  Button,
  editorConfigOptions,
  ErrorAlert,
  ErrorMessage,
  Header,
  JoditEditor,
  success,
  useCustomForm,
  useFetchData,
  useRef,
} from "@";
import { getSaveTermsConditions } from "./utils/api";
import { defaultValues, summarySchema } from "./utils/validation";

const TermsConditions = () => {
  // stats and variables
  const editor = useRef(null);
  const links = [
    { name: "الصفحات", link: "/website/pages" },
    { name: "تعديل", link: "" },
  ];

  // Use form
  const { reset, watch, errors, setValue, handleSubmit, isSubmitting } =
    useCustomForm(defaultValues, summarySchema);

  const { error, fetchData } = useFetchData({
    reset: reset,
    fun: getSaveTermsConditions,
  });

  // save data
  const submit = async (data) => {
    try {
      await getSaveTermsConditions(data);
      success("تم التعديل بنجاح");
    } catch (error) {}
  };

  return (
    <>
      {/* error alert */}
      <ErrorAlert reload={fetchData} show={error} />
      <Header title="الشروط والأحكام" links={links} />

      <form onSubmit={handleSubmit(submit)}>
        <div className="card p-4">
          <h4 className="mb-4">محتوى الصفحة</h4>

          <JoditEditor
            ref={editor}
            tabIndex={1}
            config={editorConfigOptions}
            value={watch("summary")}
            onChange={(newContent) => setValue("summary", newContent)}
          />
          <ErrorMessage value={errors.summary?.message} />
        </div>

        <Button isLoading={isSubmitting} type="submit" title="حفظ البيانات" />
      </form>
    </>
  );
};

export default TermsConditions;
